interface CarouselChevronIconProps {
  width?: string | number;
  height?: string | number;
  fill?: string;
}

const CarouselChevronIcon = ({
  width = "16",
  height = "16",
  fill = "#111928",
}: CarouselChevronIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_carousel_chevron)">
      <path
        d="M12.2389 7.36777C12.587 7.71595 12.587 8.27896 12.2389 8.62343L5.12714 15.7389C4.77896 16.087 4.21595 16.087 3.87147 15.7389C3.527 15.3907 3.5233 14.8277 3.87147 14.4832L10.3535 8.00116L3.86777 1.51541C3.51959 1.16723 3.51959 0.604221 3.86777 0.259746C4.21595 -0.0847281 4.77896 -0.0884321 5.12343 0.259746L12.2389 7.36777Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_carousel_chevron">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CarouselChevronIcon;
